import { render, staticRenderFns } from "./dailyMsgDialog.vue?vue&type=template&id=3e4e1579&scoped=true"
import script from "./dailyMsgDialog.vue?vue&type=script&lang=js"
export * from "./dailyMsgDialog.vue?vue&type=script&lang=js"
import style0 from "./dailyMsgDialog.vue?vue&type=style&index=0&id=3e4e1579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4e1579",
  null
  
)

export default component.exports